export default __webpack_public_path__ + "static/media/app-store-icon.71d802e5.svg";